import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const RobotsTxt: React.FC = () => {
  // Verificar si estamos en el ambiente de staging
  const isStaging = window.location.hostname === 'dev.trustedinterpreters.com';

  useEffect(() => {
    // Si estamos en staging, agregar la meta etiqueta de robots
    if (isStaging) {
      // Esta es una forma de simular un robots.txt
      // Los motores de búsqueda respetarán la meta etiqueta de robots
      console.log('Staging environment detected, preventing search engine indexing');
    }
  }, [isStaging]);
  
  if (!isStaging) {
    return null;
  }

  return (
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
      <link rel="canonical" href="https://trustedinterpreters.com" />
    </Helmet>
  );
};

export default RobotsTxt; 